const state = {
  tncweb: [],
  tncuser: [],
  tnchero: [],
  tnc_id: [],
};

export default state;
